import jsonp from 'jsonp';
import axios from 'axios';
import * as utils from '@utils';

const JSONP_TIMEOUT = 10000;
const AXIOS_TIMEOUT = 30000;

const objToAjaxParams = (data) => {
  let txtArr = [];
  for (let key in data) {
    txtArr.push(`${key}=${data[key]}`);
  }
  txtArr.push('callback');
  return txtArr.join('&');
};

export const getJSON = (url, data = {}) => {
  return new Promise((resolve) => {
    jsonp(
      url,
      {
        param: objToAjaxParams({
          ...data,
          cid: utils.getUrlParams('cid'),
          scid: utils.getUrlParams('scid')
        }),
        prefix: 'jsonpCallback',
        timeout: JSONP_TIMEOUT
      },
      (err, res) => {
        // 失败时 resolve(undefined)，调用方通过 +res?.result === 1 判断成功
        if (err) {
          resolve(undefined);
        } else {
          resolve(res);
        }
      }
    );
  });
};

export const get = (url, data) => {
  return new Promise((resolve) => {
    axios
      .get(url, {
        params: data || {},
        timeout: AXIOS_TIMEOUT
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        resolve(res?.data || {});
      });
  });
};

export const post = (url, data, responseType = 'json') => {
  return new Promise((resolve) => {
    axios({
      method: 'post',
      url,
      data: data,
      responseType,
      timeout: AXIOS_TIMEOUT
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        resolve(res?.data || {});
      });
  });
};
